export default __webpack_public_path__ + "static/media/20.7379b80f.png";